import { render, staticRenderFns } from "./MpFollows.vue?vue&type=template&id=5e9c8345&"
import script from "./MpFollows.vue?vue&type=script&lang=js&"
export * from "./MpFollows.vue?vue&type=script&lang=js&"
import style0 from "./MpFollows.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports